/**
 * Custom Javascript Code for PROfertil theme.
 *
 * @author Eberhard Lauth
 *
 */
( function ( $ ) {
    /**
     * Re-Initialize Foundation's equalizer on window.load.
     * Because equalizing doesn't work in firefox e.g. without this fix.
     */
    $( window ).load( function() {
        if ( Foundation.Equalizer.length ) {
            Foundation.reInit( 'equalizer' );
        }
    });

    /*Add domain and language path to to <body>*/
    var hostname = $(location).attr('hostname').replace(/\./g, '-');
    var pathname = $(location).attr('pathname').substr(1,2);

    $('body').addClass(hostname).addClass(pathname);

    /*Set all (R) and (TM) symbols to superscript*/
    $('body :not(script)').contents().filter(function () {
        return this.nodeType === 3;
    }).replaceWith(function () {
        return this.nodeValue.replace(/[™®]/g, '<sup>$&</sup>');
    });
    

} )( jQuery );